import { useState, useEffect, useRef } from 'react';
import { pacientesStore, resourcesCollection } from '../utils/firebase';

/*
  Estructura del documento en colección "resources":
  {
    Activo         : true
    Building_Id    : "Hospital-MAC-Los Mochis"   ← igual al campo calendar del usuario
    Capacity       : "5"
    Floor_Name     : "PB"
    Resource_Category : "CONFERENCE_ROOM"
    Resource_Id    : "8111111148"
    Resource_Name  : "Endoscopia "
    Resource_Type  : "Quirófano"
  }
*/

const useResources = (calendar) => {
  const [salas,   setSalas]   = useState([]);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (!calendar) return;
    setLoading(true);

    const unsub = pacientesStore
      .collection(resourcesCollection)
      .where('Building_Id', '==', calendar)
      .where('Activo', '==', true)
      .onSnapshot(
        (snap) => {
          if (!mounted.current) return;
          const list = [];
          snap.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
          // Ordenar por nombre de sala
          list.sort((a, b) =>
            (a.Resource_Name || '').trim().localeCompare((b.Resource_Name || '').trim())
          );
          setSalas(list);
          setLoading(false);
        },
        (err) => {
          if (!mounted.current) return;
          console.error('useResources:', err);
          setLoading(false);
        }
      );

    return () => unsub();
  }, [calendar]);

  return { salas, loading };
};

export default useResources;
